export default ({ app }) => {
    app.router.afterEach((to) => {
      if (to.name && to.name.startsWith('checkout') || to.path.startsWith('/sveacheckout')) {
        document.body.classList.add('checkout-page');
      } else {
        document.body.classList.remove('checkout-page');
      }
    });
};